import { render, staticRenderFns } from "./view-bulk-message.vue?vue&type=template&id=5efbaf44&scoped=true&"
import script from "./view-bulk-message.vue?vue&type=script&lang=js&"
export * from "./view-bulk-message.vue?vue&type=script&lang=js&"
import style0 from "./view-bulk-message.vue?vue&type=style&index=0&id=5efbaf44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efbaf44",
  null
  
)

export default component.exports